import React, { memo, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";

import { useFilteredData } from "../../Hooks";
import { dateFormat } from "../../helper/common";
import { Label, CustomSelect, Button, DateRangePicker } from "../";

const MarketFilter = ({
  isSport = false,
  isTournament = false,
  isMatch = false,
  allMatch = false,
  handleFilterParams,
  apiParam,
  defaultParams = {},
  isBulkOperation = false,
  isType = false,
  isBettingType = false,
  marketTypeData = [],
  isDate = false,
  isRole = false,
  handleShowHide,
  autoSelectFirstSport = false,
}) => {
  const { control, handleSubmit, watch, setValue, reset } = useForm({
    defaultValues: {
      sports: null,
      tournament: null,
      match: null,
      marketType: null,
      startDate: null,
      endDate: null,
      bettingType: null,
      ...defaultParams,
    },
  });

  const watchSports = watch("sports");
  const watchTournament = watch("tournament");
  const watchBettingType = watch("bettingType");

  const { sportOptions, tournamentOptions, matchOptions, bettingTypeOptions } =
    useFilteredData({
      sport: watchSports?.value,
      tournament: watchTournament?.value,
      dependantMatch: isMatch,
      allMatch,
      enableTournament: isTournament,
      apiParam,
      isType,
      enableBettingType: isSport,
      enableRole: isRole,
    });

  useEffect(() => {
    if (defaultParams?.sportId && sportOptions.length > 0 && !watchSports) {
      const selectedSport = sportOptions.find(
        (option) => String(option.value) === String(defaultParams.sportId),
      );

      if (selectedSport) {
        setValue("sports", selectedSport);
      }
    }
  }, [defaultParams?.sportId, sportOptions, setValue, watchSports]);

  useEffect(() => {
    if (
      defaultParams?.bettingTypeId &&
      bettingTypeOptions.length > 0 &&
      !watchBettingType
    ) {
      const selectedBettingType = bettingTypeOptions.find(
        (option) =>
          String(option.value) === String(defaultParams.bettingTypeId),
      );

      if (selectedBettingType) {
        setValue("bettingType", selectedBettingType);
      }
    }
  }, [
    defaultParams?.bettingTypeId,
    bettingTypeOptions,
    setValue,
    watchBettingType,
  ]);
  useEffect(() => {
    if (
      autoSelectFirstSport &&
      !defaultParams.sportId &&
      sportOptions.length > 0 &&
      !watchSports
    ) {
      const firstSport = sportOptions[0];

      setValue("sports", firstSport);

      handleFilterParams({
        sports: firstSport,
      });
    }
  }, [
    autoSelectFirstSport,
    defaultParams.sportId,
    sportOptions,
    watchSports,
    setValue,
    handleFilterParams,
  ]);
  const onSubmit = (values) => {
    const startDate = values?.startDate
      ? dateFormat(values?.startDate).formattedDate
      : null;

    const endDate = values?.endDate
      ? dateFormat(values?.endDate).formattedDate
      : null;

    const payload = {
      ...values,
      startDate,
      endDate,
    };

    handleFilterParams(payload);
  };

  const handleClear = () => {
    const clearedValues = {
      sports: null,
      tournament: null,
      match: null,
      marketType: null,
      bettingType: null,
      startDate: null,
      endDate: null,
    };

    reset(clearedValues);

    handleFilterParams(clearedValues);
  };

  return (
    <form className="filter_tableBox" onSubmit={handleSubmit(onSubmit)}>
      <div className="row align-items-end">
        {isSport && (
          <div className="col-lg-2 col-md-6 col-12 m-0 p-1">
            <div className="input_control">
              <Label htmlFor="sports" className="form-label">
                Sports
                {/* <span className="text-danger">*</span> */}
              </Label>

              <Controller
                name="sports"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    options={sportOptions}
                    value={field.value}
                    onChange={(selected) => {
                      field.onChange(selected);
                      setValue("tournament", null);
                      setValue("match", null);
                      setValue("bettingType", null);
                    }}
                    placeholder="Select Sports"
                    isMulti={false}
                  />
                )}
              />
            </div>
          </div>
        )}

        {isTournament && (
          <div className="col-lg-2 col-md-6 col-12 m-0 p-1">
            <div className="input_control">
              <Label htmlFor="tournament" className="form-label">
                Tournament
                {/* <span className="text-danger">*</span> */}
              </Label>

              <Controller
                name="tournament"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    options={tournamentOptions}
                    value={field.value}
                    onChange={(selected) => {
                      field.onChange(selected);
                      setValue("match", null);
                    }}
                    placeholder="Select Tournament"
                    isMulti={false}
                  />
                )}
              />
            </div>
          </div>
        )}

        {isMatch && (
          <div className="col-lg-2 col-md-6 col-12 m-0 p-1">
            <div className="input_control">
              <Label htmlFor="match" className="form-label">
                Matches
                {/* <span className="text-danger">*</span> */}
              </Label>

              <Controller
                name="match"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    options={matchOptions}
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Select Match"
                    isMulti={false}
                  />
                )}
              />
            </div>
          </div>
        )}

        {isBettingType && (
          <div className="col-lg-2 col-md-6 col-12 m-0 p-1">
            <div className="input_control">
              <Label htmlFor="bettingType" className="form-label">
                BettingType
                {/* <span className="text-danger">*</span> */}
              </Label>

              <Controller
                name="bettingType"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    options={bettingTypeOptions}
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="All"
                    isMulti={false}
                  />
                )}
              />
            </div>
          </div>
        )}

        {isType && marketTypeData && (
          <div className="col-lg-2 col-md-6 col-12 m-0 p-1">
            <div className="input_control">
              <Label htmlFor="marketType" className="form-label">
                Type
                {/* <span className="text-danger">*</span> */}
              </Label>

              <Controller
                name="marketType"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    options={marketTypeData}
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Select marketType"
                    isMulti={false}
                  />
                )}
              />
            </div>
          </div>
        )}

        {isDate && (
          <DateRangePicker
            values={watch()}
            setFieldValue={setValue}
            className="col-lg-2 col-md-6 col-6 m-0 p-1"
          />
        )}

        <div className="col-xl-2 col-lg-4 col-12">
          <div className="btn_box">
            <Button type="submit" className="btn_submit">
              Search
            </Button>

            <Button type="button" className="btn_clear" onClick={handleClear}>
              Clear
            </Button>
          </div>
        </div>

        {isBulkOperation && (
          <div className="col-xl-1 col-lg-4 col-12">
            <div className="btn_box">
              <Button
                type="button"
                className="btn_submit"
                onClick={handleShowHide}
              >
                Bulk Operation
              </Button>
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default memo(MarketFilter);
